import React from "react";
import { Route, Switch } from "react-router-dom";

// App Views
import Home from "../views/Home";
import MarriageAnnouncement from "../views/MarriageAnnouncement";

import NotFound from "../views/NotFound";

class PageRouter extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/announcement" component={MarriageAnnouncement} />

        <Route componenet={NotFound} />
      </Switch>
    );
  }
}

export default PageRouter;



// WEBPACK FOOTER //
// ./src/routes/PageRouter.js